// extracted by mini-css-extract-plugin
export default {"StudentReviewsPage":"StudentReviews_StudentReviewsPage__AJRcw","PageName":"StudentReviews_PageName__+DNhe"};